import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Albaran} from '../../../models/albaran';
import {AlbaranService} from "../../../services/albaran.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Matricula} from "../../../models/matricula";
import {AuthService} from "../../../services/auth.service";
import {Lloc} from "../../../models/lloc";
import {lastValueFrom, Subscription} from 'rxjs';
import {ZXingScannerComponent} from "@zxing/ngx-scanner";
import {BarcodeFormat, BrowserQRCodeSvgWriter, EncodeHintType} from "@zxing/library";
import {ToastController} from "@ionic/angular";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {QrDriver} from "../../../drivers/qr.driver";
import {TransportStatus} from "../../../data/TransportStatus";
import {Deca} from "../../../models/deca";
import {DecaCacheService} from "../../../services/deca-cache.service";
import {todayLocal} from "../../../services/date-helper";
import {ConnectionService} from "../../../services/connection.service";
import {DataCacheService} from "../../../services/data-cache.service";

@Component({
    selector: 'app-albaran-list',
    templateUrl: './albaran-list.component.html',
    styleUrls: ['./albaran-list.component.scss'],
    standalone: false
})
export class AlbaranListComponent implements OnInit, OnDestroy {

    nameSection = "Lista albaranes";

    // Día (Y-m-d) con el que se cargó la lista: si la app vuelve de segundo plano en otro día,
    // hay que pasar al día de hoy sin esperar a que el xofer recargue.
    loadedDay: string = "";
    private onVisibilityChange = () => this.checkDayChange();
    private restoredSubscription?: Subscription;

    @ViewChild('selectElement') selectElement!: any;

    inputFiltroAlbaran: string = "";
    inputFiltroAlbaranDate: string = "";

    nomXofer: any;
    matriculaXofer: any;
    selectedTuition: any;

    matriculas: Matricula[] = [];
    albaranes: Albaran[] = [];

    valorRecibido: number = -1;
    tareasHechasTotales: number = 0;
    tareasPendientesTotales: number = 0;

    loaderShow: boolean = false;
    boolHiddeBtnClearFilters: boolean = true;

    showAlertErrorGetAlbaranes: boolean = false;
    messageErrorGetAlbaranes: string = "";

    showQuestionDestiny: boolean = false;
    showAlertSaveTracking: boolean = false;
    messageAlertSaveTracking: string = "";
    listFirstDestinyXofer: Lloc[] = [];
    selectedCheckboxId: string | null = null;
    firstDestiny: any;

    showAdvanceAlbaran: boolean = false;
    showCardAdvanceAlbaran: boolean = false;
    showCameraAdvanceAlbarans: boolean = false;
    showMessageAdvancedAlbaranNotFound: boolean = false;
    showDecaQRList: boolean = false;
    decas: Deca[] = [];
    includeFinishedDecas: boolean = false;
    // Aviso cuando la lista de albaranes viene de la copia local, con la hora de descarga
    albaranesBackupNotice: string | null = null;
    // Aviso cuando la lista viene de la copia local (sin cobertura), con la hora de descarga
    decaBackupNotice: string | null = null;
    // SVG del QR de cada DeCA, indexado por idAlbara. Se genera en la app a partir de la URL.
    decaQrSvg: { [idAlbara: number]: SafeHtml } = {};
    albaranId: string = "";
    advancedAlbaran: Albaran = new Albaran();

    @ViewChild('scanner', {static: true}) scanner: ZXingScannerComponent | undefined;

    public procesing = false;
    public enabled = true;

    name = "Lector QR";

    formatsEnabled: BarcodeFormat[] = [
        BarcodeFormat.CODE_128,
        BarcodeFormat.DATA_MATRIX,
        BarcodeFormat.EAN_13,
        BarcodeFormat.QR_CODE
    ];

    availableDevices?: MediaDeviceInfo[];
    deviceCurrent?: MediaDeviceInfo;
    deviceSelected?: MediaDeviceInfo;

    showCheck = false;
    showFail = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private albaranService: AlbaranService,
        private auth: AuthService,
        private qrDriver: QrDriver,
        private toast: ToastController,
        private sanitizer: DomSanitizer,
        private decaCache: DecaCacheService,
        public connection: ConnectionService,
        private dataCache: DataCacheService,
    ) {
    }

    async ngOnInit() {
        this.route.params.subscribe(params => {
            this.valorRecibido = params['idAlbara'];
        });

        this.loadedDay = todayLocal();

        // Al recuperar la conexión se recarga sola la vista que esté abierta
        this.restoredSubscription?.unsubscribe();
        this.restoredSubscription = this.connection.restored.subscribe(() => this.reloadAfterReconnect());

        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.loaderShow = true;

        if (this.valorRecibido) {
            try {
                let lasTransportDate: any = await lastValueFrom(this.albaranService.getLastTransportDate(this.valorRecibido));
                if (lasTransportDate != 0 || lasTransportDate != '0') {
                    await this.router.navigate(['/albaran', this.valorRecibido, lasTransportDate]);
                }
            } catch (error) {
                // Sin conexión no se puede saber su transporte: se sigue con la lista
                this.connection.reportError(error);
            }
        }

        try {
            const xofers: any = await lastValueFrom(this.albaranService.getNameXofer());
            this.nomXofer = xofers.nomXofer;
            this.matriculaXofer = xofers.matriculaXofer;
            this.matriculas = xofers.matriculas;

            if (localStorage.getItem('matricula') === null) {
                localStorage.setItem('matricula', this.matriculaXofer);
            }

            this.selectedTuition = localStorage.getItem('matricula');

            const actualDate = new Date();
            const dd = String(actualDate.getDate()).padStart(2, '0');
            const mm = String(actualDate.getMonth() + 1).padStart(2, '0');
            const yyyy = actualDate.getFullYear();

            this.inputFiltroAlbaranDate = yyyy + '-' + mm + '-' + dd;
            //this.inputFiltroAlbaranDate = "2015-08-26";

            let dateAdvancedAlbarans: any = localStorage.getItem("dateAdvancedAlbarans");

            if (dateAdvancedAlbarans !== this.inputFiltroAlbaranDate) {
                localStorage.removeItem("advancedAlbarans");
                localStorage.removeItem("dateAdvancedAlbarans");
            }

            let advancedAlbarans = localStorage.getItem("advancedAlbarans");

            let albaranes: any;

            if (advancedAlbarans)
                albaranes = await lastValueFrom(this.albaranService.getAlbaranes(advancedAlbarans));
            else
                albaranes = await lastValueFrom(this.albaranService.getAlbaranes(null));

            this.tareasHechasTotales = 0;
            this.tareasPendientesTotales = 0;
            this.albaranes = [];
            if (albaranes.length > 0) {
                for (let albaran of albaranes) {
                    if (this.valorRecibido === undefined || this.valorRecibido.toString() === albaran.id.toString()) {
                        this.albaranes.push(albaran);
                        this.tareasHechasTotales += parseInt(albaran.numeroTareasHechas, 10);
                        this.tareasPendientesTotales += parseInt(albaran.numeroTareas, 10);
                    }
                }
            }

            const registros = Object.values(this.albaranes);

            registros.sort((a, b) => {
                if (a.estat === "Pre assignat" && b.estat !== "Pre assignat") {
                    return -1;
                } else if (a.estat !== "Pre assignat" && b.estat === "Pre assignat") {
                    return 1;
                } else {
                    return 0;
                }
            });

            this.albaranes = registros;

            this.showQuestionDestiny = this.auth.showQuestionDestiny;

            if (this.showQuestionDestiny) {
                const destiny: any = await lastValueFrom(this.albaranService.getListFirstDestinyXofer(this.inputFiltroAlbaranDate));
                this.listFirstDestinyXofer = destiny;
                this.auth.showQuestionDestiny = false;
            }

            this.saveAlbaranesBackup();

            this.connection.reportSuccess();
            this.loaderShow = false;
        } catch (error) {
            this.loaderShow = false;

            // Sin conexión no se echa al xofer al login: sigue con la sesión iniciada, con la
            // etiqueta fija de "Sin conexión" y la última copia de sus albaranes y DeCAs.
            if (this.connection.reportError(error)) {
                this.inputFiltroAlbaranDate = todayLocal();
                this.showAlbaranesFromBackup();
                return;
            }

            await this.router.navigate(['/login']);
            console.log(error);
        }
    }

    ngOnDestroy() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.restoredSubscription?.unsubscribe();
    }

    // Vuelve la cobertura: se piden otra vez los datos de la pantalla, que hasta ahora eran copia
    async reloadAfterReconnect() {
        this.albaranesBackupNotice = null;

        if (this.showDecaQRList) {
            this.getDecas();
        } else {
            await this.ngOnInit();
        }
    }

    // La app vuelve a primer plano: si ha cambiado el día, la fecha pasa a hoy, se recarga la
    // vista que esté activa (albaranes o DeCAs) y se renueva la copia local de DeCAs.
    checkDayChange() {
        if (document.visibilityState !== 'visible') return;

        const today = todayLocal();
        if (today === this.loadedDay) return;

        this.loadedDay = today;
        this.inputFiltroAlbaranDate = today;

        if (this.showDecaQRList) {
            this.getDecas(); // al cargar los DeCAs de hoy ya renueva la copia local
        } else {
            this.getAlbaranesFiltrados();
            this.decaCache.refresh();
        }
    }

    // Guarda la lista tal como ha llegado del servidor, para poder enseñarla sin cobertura. Con un
    // albarán buscado por QR la lista viene recortada a ese: eso no puede pisar la copia del día.
    saveAlbaranesBackup() {
        if (this.valorRecibido !== undefined) return;

        this.albaranesBackupNotice = null;

        this.dataCache.saveAlbaranes({
            nomXofer: this.nomXofer,
            matriculaXofer: this.matriculaXofer,
            matriculas: this.matriculas,
            albaranes: this.albaranes,
            tareasHechasTotales: this.tareasHechasTotales,
            tareasPendientesTotales: this.tareasPendientesTotales,
        });

        this.dataCache.pruneAlbaranInfo(this.albaranes);
        this.prefetchAlbaranInfo();
    }

    /**
     * Se baja la ficha de cada albarán de la lista mientras hay cobertura, sin esperar a que el
     * xofer entre en ellos: si espera a que entre, cuando se quede sin cobertura no tendrá copia
     * justo del albarán que necesita. Va de una en una para no cargar una conexión mala y, si una
     * falla por red, se deja el resto para la próxima vez.
     */
    async prefetchAlbaranInfo() {
        for (const albaran of this.albaranes) {
            try {
                const info: any = await lastValueFrom(this.albaranService.getInfoAlbaran(albaran.id));
                this.dataCache.saveAlbaranInfo(albaran.id, info);
            } catch (error) {
                if (this.connection.isOfflineError(error)) return;
            }
        }
    }

    // Enseña la última copia guardada de la lista, con un aviso de cuándo se descargó. Sin copia,
    // la lista queda vacía: la etiqueta de "Sin conexión" ya explica por qué.
    showAlbaranesFromBackup() {
        // Sin conexión solo se puede enseñar el día de hoy: la copia es de hoy
        this.inputFiltroAlbaranDate = todayLocal();

        const backup = this.dataCache.getAlbaranes();

        if (!backup) {
            this.selectedTuition = localStorage.getItem('matricula');
            this.albaranes = [];
            this.tareasHechasTotales = 0;
            this.tareasPendientesTotales = 0;
            this.albaranesBackupNotice = 'Sin conexión y sin copia guardada de tus albaranes.';
            return;
        }

        this.nomXofer = backup.nomXofer;
        this.matriculaXofer = backup.matriculaXofer;
        this.matriculas = backup.matriculas ?? [];
        this.albaranes = backup.albaranes ?? [];
        this.tareasHechasTotales = backup.tareasHechasTotales;
        this.tareasPendientesTotales = backup.tareasPendientesTotales;
        this.selectedTuition = localStorage.getItem('matricula') ?? backup.matriculaXofer;

        this.albaranesBackupNotice = 'Sin conexión: se muestra la copia de tus albaranes '
            + this.dataCache.describe(backup) + '. No se pueden marcar tareas hasta recuperar cobertura.';
    }

    saveDestinationPlaceId(idLloc: any) {
        if (this.selectedCheckboxId === idLloc) {
            this.selectedCheckboxId = null;
            this.firstDestiny = null;
        } else {
            this.selectedCheckboxId = idLloc;
            this.firstDestiny = idLloc;
        }
    }

    saveFirstDestiny() {
        this.loaderShow = true;
        this.showQuestionDestiny = false;

        this.albaranService.saveFirstDestinyXofer(this.firstDestiny, this.selectedTuition, this.inputFiltroAlbaranDate).subscribe(
            {
                next: next => {
                    this.showAlertSaveTracking = true;
                    this.messageAlertSaveTracking = "Guardado correctamente.";

                    this.loaderShow = false;
                }, error: error => {
                    this.showAlertSaveTracking = true;
                    this.messageAlertSaveTracking = "Error al guardar el sitio al que te diriges.";

                    this.loaderShow = false;
                }
            }
        );
    }

    closeSaveFirstDestiny() {
        this.showQuestionDestiny = false;
    }

    closeAlertSaveFirstDestiny() {
        this.showAlertSaveTracking = false;
    }

    getActiveSpans(deliveryNote: Albaran): string[] {
        const spans = [];
        if (deliveryNote.esAdr === 1) spans.push('ADR');
        if (deliveryNote.esPortaElevadora === 1) spans.push('PE');
        if (deliveryNote.esExpress === 1) spans.push('EX');
        if (deliveryNote.esRemuntable === 1) spans.push('R');
        if (deliveryNote.pnstrm === 1) spans.push('PNS');
        return spans;
    }

    getClassForStatus(status: string): string {
        switch (status) {
            case TransportStatus.preAssigned:
                return 'pre-assigned-delivery-note';
            case TransportStatus.assigned:
                return 'assigned-delivery-note';
            case TransportStatus.partiallyAssigned:
                return 'partially-assigned-delivery-note';
            case TransportStatus.initiated:
                return 'initiated-delivery-note';
            case TransportStatus.completed:
                return 'completed-delivery-note';
            case TransportStatus.postponed:
                return 'postponed-delivery-note';
            case TransportStatus.cancelled:
                return 'cancelled-delivery-note';
            case TransportStatus.pending:
                return 'pending-delivery-note';
            case TransportStatus.preCompleted:
                return 'pre-completed-delivery-note';
            default:
                return '';
        }
    }

    getAlbaranesFiltrados() {
        let fecha = new Date('2000-01-01')
        let fechafiltro = new Date(this.inputFiltroAlbaranDate)
        let currentDate = new Date();

        if (currentDate < fechafiltro) {
            this.messageErrorGetAlbaranes = "No se pueden mostrar albaranes con fechas posteriores a la actual.";
            this.showAlertErrorGetAlbaranes = true;
            this.albaranes = [];

            return;
        }

        if (fechafiltro > fecha) {
            this.boolHiddeBtnClearFilters = !this.boolHiddeBtnClearFilters;
            if (this.boolHiddeBtnClearFilters)
                this.boolHiddeBtnClearFilters = !this.boolHiddeBtnClearFilters;

            this.tareasHechasTotales = 0;
            this.tareasPendientesTotales = 0;

            this.albaranService.getAlbaranesFiltrados(this.inputFiltroAlbaranDate, this.inputFiltroAlbaran).subscribe(
                {
                    next: albaranes => {
                        this.showAlertErrorGetAlbaranes = false;

                        this.albaranes = albaranes;

                        albaranes.forEach((albaran: any) => {
                            this.tareasHechasTotales += parseInt(albaran.numeroTareasHechas, 10);
                            this.tareasPendientesTotales += parseInt(albaran.numeroTareas, 10);
                        });

                        //this.tareasPendientesTotales = albaranes.length * 6;

                        const registros = Object.values(this.albaranes);

                        registros.sort((a, b) => {
                            if (a.statusCode == TransportStatus.preAssigned && b.statusCode != TransportStatus.preAssigned) {
                                return -1;
                            } else if (a.statusCode != TransportStatus.preAssigned && b.statusCode == TransportStatus.preAssigned) {
                                return 1;
                            }

                            if (a.statusCode == TransportStatus.partiallyAssigned && b.statusCode != TransportStatus.partiallyAssigned) {
                                return -1;
                            } else if (a.statusCode != TransportStatus.partiallyAssigned && b.statusCode == TransportStatus.partiallyAssigned) {
                                return 1;
                            }

                            if (a.statusCode == TransportStatus.assigned && b.statusCode != TransportStatus.assigned) {
                                return -1;
                            } else if (a.statusCode != TransportStatus.assigned && b.statusCode == TransportStatus.assigned) {
                                return 1;
                            }

                            if (a.statusCode == TransportStatus.initiated && b.statusCode != TransportStatus.initiated) {
                                return -1;
                            } else if (a.statusCode != TransportStatus.initiated && b.statusCode == TransportStatus.initiated) {
                                return 1;
                            }

                            return 0;
                        });

                        this.albaranes = [];
                        this.albaranes = registros;

                        this.connection.reportSuccess();

                        // Solo es la lista completa del día cuando no hay filtro por referencia
                        if (!this.inputFiltroAlbaran && this.inputFiltroAlbaranDate === todayLocal()) {
                            this.saveAlbaranesBackup();
                        }
                    }, error: error => {
                        // Sin cobertura se enseña la copia en vez de vaciar la lista
                        if (this.connection.reportError(error)) {
                            this.showAlbaranesFromBackup();
                            return;
                        }

                        this.messageErrorGetAlbaranes = error.error?.message ?? "No se han podido obtener los albaranes.";
                        this.showAlertErrorGetAlbaranes = true;
                        this.albaranes = [];
                    }
                }
            )
        }
    }

    changeToken() {
        let selectedTuition = this.selectedTuition;
        let tuitonSearched = this.matriculas.find(function (objeto) {
            return objeto.matricula === selectedTuition;
        });

        if (tuitonSearched) {
            this.auth.chengeTokenByTuiton(this.selectedTuition, tuitonSearched.idXofer).subscribe(
                {
                    next: async next => {
                        localStorage.setItem('token', next.token);
                        localStorage.setItem('matricula', this.selectedTuition);
                        await this.ngOnInit();

                        // La copia local de DeCAs era del xofer anterior: renovarla con el nuevo token
                        this.decaCache.refresh();

                        if (this.showDecaQRList) {
                            this.getDecas();
                        }
                    }, error: error => {
                        // Sin esto el desplegable se quedaba enseñando una matrícula que no era la
                        // activa: se devuelve a la que sigue en uso y se explica por qué.
                        this.selectedTuition = localStorage.getItem('matricula') ?? this.matriculaXofer;

                        this.messageErrorGetAlbaranes = this.connection.reportError(error)
                            ? "Sin conexión: no se ha podido cambiar de matrícula. Inténtalo de nuevo cuando recuperes cobertura."
                            : (error.error?.message ?? "No se ha podido cambiar de matrícula.");
                        this.showAlertErrorGetAlbaranes = true;
                    }
                }
            )
        }
    }

    async clearFilters() {
        this.albaranes = [];
        this.inputFiltroAlbaran = "";
        this.inputFiltroAlbaranDate = "";
        this.boolHiddeBtnClearFilters = !this.boolHiddeBtnClearFilters;
        await this.ngOnInit();

        if (this.showDecaQRList) {
            this.getDecas();
        }
    }

    vaciarInputDate() {
        // Sin conexión la fecha se queda en hoy: no hay forma de traer otro día
        if (this.connection.offline) return;

        this.inputFiltroAlbaranDate = "";
    }

    closeAlertError() {
        this.showAlertErrorGetAlbaranes = false;
    }

    async advanceAlbaran(): Promise<void> {
        this.showAdvanceAlbaran = false;
        this.showCardAdvanceAlbaran = false;
        this.loaderShow = true;

        try {
            let albarans = await lastValueFrom(this.albaranService.getAdvanceAlbaran(this.albaranId));

            this.advancedAlbaran = <Albaran>albarans;

            if (this.advancedAlbaran.idAlbara) {
                this.showCardAdvanceAlbaran = true;
                this.showCameraAdvanceAlbarans = false;
            } else {
                this.showCameraAdvanceAlbarans = false;
                this.showMessageAdvancedAlbaranNotFound = true;
            }

            this.loaderShow = false;
            this.showAdvanceAlbaran = true;
        } catch (error) {
            // Antes el modal se cerraba sin decir nada y el xofer no sabía si se había avanzado
            this.loaderShow = false;

            this.messageErrorGetAlbaranes = this.connection.reportError(error)
                ? "Sin conexión: no se ha podido buscar el albarán para avanzarlo. Inténtalo de nuevo cuando recuperes cobertura."
                : ((error as any)?.error?.message ?? "No se ha podido buscar el albarán para avanzarlo.");
            this.showAlertErrorGetAlbaranes = true;
        }
    }

    async saveAdvancedAlbaran(idAlbara: string): Promise<void> {
        let oldArray: any = localStorage.getItem("advancedAlbarans");

        if (oldArray) {
            let newArray = JSON.parse(oldArray);

            newArray.push(idAlbara);

            localStorage.removeItem("advancedAlbarans")
            localStorage.setItem("advancedAlbarans", JSON.stringify(newArray));
        } else {
            let newArray = [idAlbara];

            localStorage.setItem("advancedAlbarans", JSON.stringify(newArray));
            localStorage.setItem("dateAdvancedAlbarans", this.inputFiltroAlbaranDate);
        }

        this.showMessageAdvancedAlbaranNotFound = false;
        this.showCameraAdvanceAlbarans = true;
        this.showCardAdvanceAlbaran = false;
        this.albaranId = "";
        this.showAdvanceAlbaran = false;
        await this.ngOnInit();
    }

    retryFoundAdvancedAlbaran(): void {
        this.showMessageAdvancedAlbaranNotFound = false;
        this.showCameraAdvanceAlbarans = true;
        this.showCardAdvanceAlbaran = false;
        this.albaranId = "";
    }

    openModalAdvanceAlbaran(): void {
        this.showAdvanceAlbaran = true;
        this.showCameraAdvanceAlbarans = true;
    }

    closeModalAdvanceAlbaran(): void {
        this.albaranId = "";
        this.showCardAdvanceAlbaran = false;
        this.showCameraAdvanceAlbarans = false;
        this.showMessageAdvancedAlbaranNotFound = false;
        this.showAdvanceAlbaran = false;
    }

    async switchToDecaView() {
        this.showDecaQRList = !this.showDecaQRList;

        if (this.showDecaQRList) {
            this.getDecas();
        } else {
            this.decas = [];
            this.decaQrSvg = {};

            // Los filtros pueden haber cambiado mientras se veían los DeCAs: recargar los albaranes.
            if (this.inputFiltroAlbaranDate) {
                this.getAlbaranesFiltrados();
            } else {
                await this.ngOnInit();
            }
        }
    }

    get decasDate(): string {
        return this.inputFiltroAlbaranDate || todayLocal();
    }

    hasDecaPdf(): boolean {
        return this.decas.some(deca => !!deca.url);
    }

    // Todos los DeCAs del día en un único PDF, para imprimirlos de golpe.
    downloadDecasPdf() {
        const fecha = this.decasDate;

        this.loaderShow = true;

        this.albaranService.getDecasPdf(fecha, this.includeFinishedDecas).subscribe(
            {
                next: (pdf: Blob) => {
                    DecaCacheService.download(pdf, 'DECA_' + fecha + '.pdf');
                    this.loaderShow = false;
                }, error: async error => {
                    // Sin conexión: la última copia del PDF del día que se pudo descargar
                    if (this.isOfflineError(error) && await this.downloadDayPdfFromBackup()) {
                        this.loaderShow = false;
                        return;
                    }

                    // Con responseType blob el error del backend llega como Blob JSON
                    let message = "No se ha podido generar el PDF de los DeCAs.";
                    try {
                        message = JSON.parse(await error.error.text()).message ?? message;
                    } catch (e) {
                    }
                    this.messageErrorGetAlbaranes = message;
                    this.showAlertErrorGetAlbaranes = true;
                    this.loaderShow = false;
                }
            }
        );
    }

    // Descarga la copia guardada del PDF del día y avisa de cuándo se bajó. false si no hay copia.
    async downloadDayPdfFromBackup(): Promise<boolean> {
        const copy = await this.decaCache.downloadDayPdfCopy();
        if (!copy) return false;

        this.messageErrorGetAlbaranes = 'Sin conexión: se ha descargado la copia del PDF de los DeCAs del '
            + this.formatDay(copy.date) + ' guardada el ' + this.formatDateTime(copy.downloadedAt)
            + ' (incluye las rutas finalizadas).';
        this.showAlertErrorGetAlbaranes = true;

        return true;
    }

    formatDay(date: string): string {
        const [year, month, day] = date.split('-');
        return day + '/' + month + '/' + year;
    }

    formatDateTime(iso: string): string {
        const d = new Date(iso);
        const pad = (n: number) => String(n).padStart(2, '0');
        return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + ' a las ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    }

    getDecas() {
        const fecha = this.decasDate;

        this.loaderShow = true;

        this.albaranService.getDecas(fecha, this.includeFinishedDecas).subscribe(
            {
                next: (response: any) => {
                    this.decas = this.filterDecasByAlbaran(response.items ?? []);
                    this.decaBackupNotice = null;
                    this.generateDecaQrs();
                    this.loaderShow = false;

                    // Hay cobertura: aprovechar para renovar la copia local de hoy
                    if (fecha === todayLocal()) {
                        this.decaCache.refresh();
                    }
                }, error: error => {
                    // Sin respuesta del servidor (p. ej. sin cobertura): enseñar la copia local
                    if (this.isOfflineError(error) && this.showDecasFromBackup()) {
                        this.loaderShow = false;
                        return;
                    }

                    this.messageErrorGetAlbaranes = error.error?.message ?? "Error al obtener los DeCAs.";
                    this.showAlertErrorGetAlbaranes = true;
                    this.decas = [];
                    this.decaQrSvg = {};
                    this.decaBackupNotice = null;
                    this.loaderShow = false;
                }
            }
        );
    }

    // El servidor no ha contestado: sin red, petición cortada o pasarela caída. Un error con
    // respuesta del backend (400, 403, 500 con mensaje) no cuenta: ese hay que enseñarlo.
    // Además enciende la etiqueta fija de "Sin conexión".
    isOfflineError(error: any): boolean {
        return this.connection.reportError(error);
    }

    // Copia local de los DeCAs descargada al arrancar la app, con la hora de descarga para que el
    // xofer sepa si es actual. Devuelve false si no hay copia.
    showDecasFromBackup(): boolean {
        const backup = this.decaCache.get();

        if (!backup) return false;

        let items = backup.items;
        if (!this.includeFinishedDecas) {
            items = items.filter(deca => !deca.finished);
        }

        this.decas = this.filterDecasByAlbaran(items);
        this.generateDecaQrs();

        const downloadedAt = new Date(backup.downloadedAt);
        const pad = (n: number) => String(n).padStart(2, '0');
        const [year, month, day] = backup.date.split('-');

        this.decaBackupNotice = 'Sin conexión: se muestra la copia de los DeCAs del ' + day + '/' + month + '/' + year
            + ' descargada el ' + pad(downloadedAt.getDate()) + '/' + pad(downloadedAt.getMonth() + 1)
            + ' a las ' + pad(downloadedAt.getHours()) + ':' + pad(downloadedAt.getMinutes()) + '.';

        return true;
    }

    // getDecas no filtra por albarán en el backend: se aplica aquí el mismo input de la lista.
    filterDecasByAlbaran(decas: Deca[]): Deca[] {
        const filtro = this.inputFiltroAlbaran.trim().toLowerCase();
        if (!filtro) return decas;

        return decas.filter(deca =>
            deca.reference.toLowerCase().includes(filtro) || String(deca.idAlbara).includes(filtro)
        );
    }

    // Los inputs de filtro son comunes a las dos listas: recarga la que esté visible.
    onFilterChange() {
        if (this.showDecaQRList) {
            this.boolHiddeBtnClearFilters = false;
            this.getDecas();
        } else {
            this.getAlbaranesFiltrados();
        }
    }

    // Con conexión abre la URL pública; sin conexión descarga la copia guardada del PDF.
    async openDecaPdf(deca: Deca) {
        // Si la lista ya viene de la copia local, el servidor no responde: ir directo a la copia del PDF
        const result = await this.decaCache.openPdf(deca.idAlbara, deca.url, 'DECA_' + deca.reference.replace('/', '-') + '.pdf', !!this.decaBackupNotice);

        if (result === 'none') {
            this.messageErrorGetAlbaranes = 'Sin conexión y sin copia guardada de este DeCA.';
            this.showAlertErrorGetAlbaranes = true;
        } else if (result === 'backup' && !this.decaBackupNotice) {
            // Se ha perdido la cobertura con la lista ya cargada: pasar la lista a modo copia con su aviso
            this.showDecasFromBackup();
        }
    }

    // La norma pide la URL dentro del QR, por eso se dibuja aquí y no lo envía el backend.
    generateDecaQrs() {
        const writer = new BrowserQRCodeSvgWriter();
        // Mismos parámetros que el <qrcode ec="H"> del PDF del DeCA (deca_pdf.php), para que el
        // QR de la app sea idéntico al impreso: misma URL y mismo nivel de corrección de errores.
        const hints = new Map<EncodeHintType, any>([[EncodeHintType.ERROR_CORRECTION, 'H']]);
        this.decaQrSvg = {};

        for (const deca of this.decas) {
            if (!deca.url) continue;

            const svg = writer.write(deca.url, 220, 220, hints);
            this.decaQrSvg[deca.idAlbara] = this.sanitizer.bypassSecurityTrustHtml(svg.outerHTML);
        }
    }

    //LECTOR QR

    ngDoCheck() {
        this.deviceCurrent = this.qrDriver.deviceCurrent;
        this.deviceSelected = this.qrDriver.deviceSelected;
        this.availableDevices = this.qrDriver.availableDevices;
        this.enabled = this.qrDriver.enabled;
    }

    browserError(error: any) {
        this.qrDriver.browserError(error);
    }

    async ionViewWillEnter() {
        this.enabled = true;
        await this.start();
    }

    async start() {
        this.qrDriver.start().then(async (code) => {
            await this.saveResult(code);
        }).finally(async () => {
            await this.start();
        });
    }

    async ionViewWillLeave() {
        this.enabled = false;
        await this.close();
    }

    async close() {
        await this.qrDriver.close();
    }

    async checkBrowser(code: string) {
        if (code && this.qrDriver.check(code)) {
            if (!this.procesing) {
                await this.saveResult(code).catch(() => {
                });
            }
        } else if (code && !this.qrDriver.check(code)) {
            const toast = await this.toast.create({
                message: 'Error de lectura',
                color: 'danger',
                position: 'bottom',
                translucent: true,
                duration: 2000
            });
            await toast.present();
        }
    }

    async saveResult(code: any) {
        console.log(code);

        this.albaranId = code;
        await this.advanceAlbaran();

        return new Promise(async (resolve, reject) => {
            //await this.router.navigate(['/albaranes', code]);
        });
    }

    flashCheck() {
        this.showCheck = true;

        setTimeout(() => {
            this.showCheck = false;
        }, 3000);
    }

    flashFail() {
        this.showFail = true;

        setTimeout(() => {
            this.showFail = false;
        }, 3000);
    }

    onCamerasFound(devices: MediaDeviceInfo[]): void {
        this.qrDriver.onCamerasFound(devices);
    }

    onDeviceSelectChange(selected: MediaDeviceInfo) {
        this.qrDriver.onDeviceSelectChange(selected);
    }

    onDeviceChange(device: MediaDeviceInfo) {
        this.qrDriver.onDeviceChange(device);
    }

    onHasPermission(has: boolean) {
        this.qrDriver.onHasPermission(has);
    }


    onTorchCompatible(isCompatible: boolean): void {
        this.qrDriver.onTorchCompatible(isCompatible);
    }

    toggleTorch(): void {
        this.qrDriver.toggleTorch();
    }

    toggleTryHarder(): void {
        this.qrDriver.toggleTryHarder();
    }

    isDifferentDate(date: string) {
        // Dividir la fecha
        const [year, month, day] = date.split('-').map(Number);

        if (isNaN(year) || isNaN(month) || isNaN(day)) {
            return true;//throw new Error("La fecha contiene valores no válidos.");
        }

        if (!year || !month || !day) {
            return true;// throw new Error('Fecha inválida o formato incorrecto');
        }

        // Crear la fecha asegurándote del formato
        const inputDate = new Date(year, month - 1, day);

        // Validar que sea una fecha válida
        if (isNaN(inputDate.getTime())) {
            return true;//throw new Error('La fecha no es válida');
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return inputDate != today
    }
}
